export const ACTION_TYPES = {
	LOGIN_USER: "LOGIN_USER",
	LOGOUT_USER: "LOGOUT_USER",
	ROLE: "USER_ROLE",
	SCHOOL_ID: "SCHOOL_ID",
	TEACHER_ID: "TEACHER_ID",
	USER_INFO: "USER_INFO",
	CLASSLINK_USER: "CLASSLINK_USER",
};

// NOTE: auth/identity keys use sessionStorage (per-tab) so two tabs on the same
// origin (e.g. admin + teacher) keep independent sessions and never clash.
export const loginUser = (data) => {
	// SET YOUR LOGIN INFO HERE
	sessionStorage.setItem("cms_isLoggedIn", true);
	return {
		type: ACTION_TYPES.LOGIN_USER,
		...data,
	};
};

export const logOutUser = () => {
	sessionStorage.removeItem("cms_isLoggedIn");
	sessionStorage.removeItem("cms_accessToken");
	sessionStorage.removeItem("cms_userInfo");
	// Identity cached for the fast-start path below. Cleared here so the next
	// login in this tab never seeds the store from the previous user.
	// NOTE: cms_loginPortal is intentionally kept - it is read AFTER logout to
	// decide which login page to send the user back to.
	sessionStorage.removeItem("cms_role");
	sessionStorage.removeItem("schoolId");
	sessionStorage.removeItem("teacherId");
	return {
		type: ACTION_TYPES.LOGOUT_USER,
	};
};

export const userRole = (role) => {
	// Persisted (per tab) so a reload can seed the store synchronously and the
	// dashboard can fire its role-scoped calls on the first render, instead of
	// waiting a full round-trip for /user/cms/status to come back again.
	if (role) sessionStorage.setItem("cms_role", role);
	return {
		type: ACTION_TYPES.ROLE,
		role,
	};
};

export const reduxSchoolId = (school_id) => {
	return {
		type: ACTION_TYPES.SCHOOL_ID,
		school_id,
	};
};

export const reduxTeacherId = (teacher_id) => {
	return {
		type: ACTION_TYPES.TEACHER_ID,
		teacher_id,
	};
};

export const userInfo = (data) => {
	sessionStorage.setItem("cms_userInfo", JSON.stringify(data));
	return {
		type: ACTION_TYPES.USER_INFO,
		userInfo: data,
	};
};

export const classLinkUser = (value) => {
	return {
		type: ACTION_TYPES.CLASSLINK_USER,
		isFromClassLink: value,
	};
};
